import 'chartjs-adapter-moment'

import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild,
} from '@angular/core'
import { Chart, ChartDataset, ChartOptions } from 'chart.js/auto'
import moment from 'moment/moment'
import { BaseChartDirective } from 'ng2-charts'

import { TooltipLine } from '../utils'
import { ChartUtilities } from '../utils/chart-utlities'

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss'],
})
export class LineChartComponent implements OnChanges {
  @ViewChild(BaseChartDirective, { static: false }) chart: BaseChartDirective

  @Input() chartHeight: string
  @Input() dataset: ChartDataset[]
  @Input() labels: string[]
  @Input() ariaLabel: string
  @Input() xMaxTicksLimit: number
  @Input() xScaleTitle: string
  yScaleTitle = 'Price'

  @Output() chartMouseOut = new EventEmitter<any>()
  @Output() activeItemChanged = new EventEmitter<any>()

  private lastActiveItem: any
  private ticksArray: any[]
  options: ChartOptions
  data: any

  ngOnChanges() {
    this.data = {
      labels: this.labels,
      datasets: this.dataset,
    }

    this.options = {
      borderColor: '#1BA39C',
      datasets: {
        line: {
          hoverBackgroundColor: 'rgb(75, 192, 192)',
          hoverBorderJoinStyle: 'bevel',
          pointStyle: 'circle',
          pointHoverBackgroundColor: 'rgb(75, 192, 192)',
          pointHoverRadius: 5,
          pointRadius: 1,
          pointBorderColor: 'rgb(75, 192, 192)',
          pointBackgroundColor: 'rgb(75, 192, 192)',
        },
      },
      responsive: true,
      hover: {
        mode: 'index',
        intersect: false,
      },
      onHover: (event, activeList) => this.chartHovered(event, activeList),
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: true,
          intersect: false,
          mode: 'index',
          callbacks: {
            title: function (tooltipItems) {
              const tooltipItem = tooltipItems[0]
              return moment(tooltipItem.label).format('MMM/DD/YYYY')
            },
            label: function (tooltipItem) {
              return `$${Number(tooltipItem.formattedValue).toFixed(2)}`
            },
          },
        },
      },
      scales: {
        x: {
          type: 'time',
          stacked: true,
          title: {
            display: false,
          },
          grid: {
            display: false,
          },
          beforeUpdate: () => (this.ticksArray = []),
          ticks: {
            maxTicksLimit: 6,
            maxRotation: 0,
            padding: 8,
            callback: (tick, index, ticks) =>
              ChartUtilities.pruneXAxisTicks(
                tick,
                index,
                ticks,
                this.xMaxTicksLimit,
                this.ticksArray,
              ),
          },
        },
        y: {
          beginAtZero: false,
          title: {
            display: Boolean(this.yScaleTitle),
            text: this.yScaleTitle,
          },
          grid: {
            display: true,
          },
          border: {
            display: false,
          },
          ticks: {
            maxTicksLimit: 4,
            padding: 20,
            callback: function (value) {
              return `$${value}`
            },
          },
          afterBuildTicks: (chart) => (chart.ticks = chart.ticks.slice(1)),
          afterFit: (scaleInstance) => (scaleInstance.width = 100),
        },
      },
    }
  }

  constructor() {
    Chart.register(TooltipLine)
  }

  chartHovered(event, activeList: any[]): void {
    if (event.type === 'mouseout') {
      this.chartMouseOut.emit(event)
    } else if (
      activeList &&
      activeList.length &&
      activeList[0] !== this.lastActiveItem
    ) {
      this.lastActiveItem = activeList[0]
      this.activeItemChanged.emit(this.lastActiveItem)
    }
  }
}
